module.exports = {
      id: "e92256ad39c57fe4f21f928314eed8e7gas-pipeline.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#e92256ad39c57fe4f21f928314eed8e7gas-pipeline.svg",
      toString: function () {
        return this.url;
      }
    }